import { myAxios } from '../../../util/myAxios';
import { CommentDto } from './commentTypes';
import { AnsweredQuestionnaireDto } from '../../../pages/answeredQuestionnaireTypes';

export function addOrUpdateComment(comment: CommentDto, questionId: number, questionnaireId: number) : Promise<AnsweredQuestionnaireDto> {
  return myAxios()
    .then(axios => axios.post('/api/v1/comment/questionnaire/' + questionnaireId + '/question/' + questionId, comment))
    .then(response => response.data)
}
